import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { IconIncluded as IconIncludedIcon } from '~components/svgs';
import { formatFullTime } from '~helpers';
import { orderRefundProcessStatus, orderRefundStatus } from '~constants';

export default class RefundProcess extends React.Component {
  constructor(props) {
    super(props);
    this.landlordRefundProcess = [
      {
        label: this.props.t('landlord.longtail_booking_detail.refund_process.cancel_by', {
          firstName: props.refund.passportFirstName,
          lastName: props.refund.passportLastName,
        }),
        status: 'done',

        updatedAt: props.refund.processes[0] ? props.refund.processes[0].createdAt : null,
      },
      {
        label: this.props.t(
          'landlord.longtail_booking_detail.refund_process.accommdation_refund_to_stcom',
        ),
        status: this.showStatus('new', props.refund.status),

        /* eslint-enable */
        updatedAt: props.refund.processes[1] ? props.refund.processes[1].createdAt : null,
      },
      {
        label: this.props.t(
          props.refund.refundMethod === 'STRIPE'
            ? 'landlord.longtail_booking_detail.refund_process.refund_to_your_account_by_landlord'
            : 'landlord.longtail_booking_detail.refund_process.refund_to_your_account',
        ),
        /* eslint-disable no-nested-ternary */

        status: this.showStatus('pending', props.refund.status),

        /* eslint-enable */
        updatedAt: props.refund.processes[2] ? props.refund.processes[2].createdAt : null,
      },
      {
        title:
          props.refund.status === orderRefundStatus.REFUNDED ||
          props.refund.status === orderRefundStatus.PENDING_REFUND
            ? this.props.t(
                'landlord.longtail_booking_detail.refund_process.payment_been_refunded_to_tenants',
              )
            : this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_refunded'),
        label:
          props.refund.status === orderRefundStatus.REFUNDED ||
          props.refund.status === orderRefundStatus.PENDING_REFUND
            ? this.props.t(
                'landlord.longtail_booking_detail.refund_process.payment_been_refunded_to_tenants',
              )
            : props.refund.status === orderRefundStatus.VOID
            ? this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_rejected')
            : this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_refunded'),

        status: this.showStatus('done', props.refund.status),

        updatedAt: props.refund.processes[2]
          ? props.refund.processes[2].createdAt
          : props.refund.status === 'VOID'
          ? props.refund.processes[1].createdAt
          : null,
      },
    ];

    this.scomRefundProcess = [
      {
        label: this.props.t('landlord.longtail_booking_detail.refund_process.cancel_by', {
          firstName: props.refund.passportFirstName,
          lastName: props.refund.passportLastName,
        }),
        status: 'done',
        /* eslint-enable */
        updatedAt: props.refund.processes[0] ? props.refund.processes[0].createdAt : null,
      },
      {
        label: this.props.t(
          props.refund.refundMethod === 'STRIPE' ||
            (props.refund.status === 'VOID' && props.refund.isTransferred)
            ? 'landlord.longtail_booking_detail.refund_process.refund_to_your_account_by_landlord'
            : 'landlord.longtail_booking_detail.refund_process.refund_to_your_account',
        ),
        /* eslint-disable no-nested-ternary */
        status: this.showStatus('pending', props.refund.status),

        /* eslint-enable */
        hasNextItem: true,
        updatedAt: props.refund.processes[1] ? props.refund.processes[1].createdAt : null,
      },
      {
        title:
          props.refund.status === orderRefundStatus.REFUNDED ||
          props.refund.status === orderRefundStatus.PENDING_REFUND
            ? this.props.t(
                'landlord.longtail_booking_detail.refund_process.payment_been_refunded_to_tenants',
              )
            : this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_refunded'),
        label:
          props.refund.status === orderRefundStatus.REFUNDED ||
          props.refund.status === orderRefundStatus.PENDING_REFUND
            ? this.props.t(
                'landlord.longtail_booking_detail.refund_process.payment_been_refunded_to_tenants',
              )
            : props.refund.status === orderRefundStatus.VOID
            ? this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_rejected')
            : this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_refunded'),
        status: this.showStatus('done', props.refund.status),
        updatedAt: props.refund.processes[1] ? props.refund.processes[1].createdAt : null,
      },
    ];
    this.accommodationRefundProcess = [
      {
        label: this.props.t('landlord.longtail_booking_detail.refund_process.cancel_by', {
          firstName: props.refund.passportFirstName,
          lastName: props.refund.passportLastName,
        }),
        status: 'done',

        updatedAt: props.refund.processes[0] ? props.refund.processes[0].createdAt : null,
      },
      {
        label: this.props.t(
          'landlord.longtail_booking_detail.refund_process.accommdation_refund_to_stcom',
        ),
        status: this.showStatus('accommodationRefundProcessNew', props.refund.status),

        /* eslint-enable */
        updatedAt: props.refund.processes[0] ? props.refund.processes[0].createdAt : null,
      },
      {
        label: this.props.t(
          props.refund.refundMethod === 'STRIPE'
            ? 'landlord.longtail_booking_detail.refund_process.refund_to_your_account_by_landlord'
            : 'landlord.longtail_booking_detail.refund_process.refund_to_your_account',
        ),
        /* eslint-disable no-nested-ternary */
        status:
          props.refund.refundMethod === 'STRIPE'
            ? this.showStatus('stripeRefundPending', props.refund.status)
            : this.showStatus('refundPending', props.refund.status),

        /* eslint-enable */
        updatedAt: props.refund.processes[1] ? props.refund.processes[1].createdAt : null,
      },
      {
        title:
          props.refund.status === orderRefundStatus.REFUNDED ||
          props.refund.status === orderRefundStatus.PENDING_REFUND
            ? this.props.t(
                'landlord.longtail_booking_detail.refund_process.payment_been_refunded_to_tenants',
              )
            : this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_refunded'),

        label:
          props.refund.status === orderRefundStatus.REFUNDED ||
          props.refund.status === orderRefundStatus.PENDING_REFUND
            ? this.props.t(
                'landlord.longtail_booking_detail.refund_process.payment_been_refunded_to_tenants',
              )
            : props.refund.status === orderRefundStatus.VOID
            ? this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_rejected')
            : this.props.t('landlord.longtail_booking_detail.refund_process.payment_been_refunded'),
        status: this.showStatus('done', props.refund.status),
        updatedAt: props.refund.processes[2]
          ? props.refund.processes[2].createdAt
          : props.refund.status === 'VOID'
          ? props.refund.processes[1].createdAt
          : null,
      },
    ];
  }

  showTemplateByRefunds = () => {
    if (this.props.refund.status === 'VOID') {
      return this.scomRefundProcess;
    }

    if (this.props.refund.refundFrom === 'ACCOMMODATION_PARTNER') {
      const process = this.accommodationRefundProcess.concat();
      if (this.props.refund.refundMethod === 'STRIPE') {
        process.splice(1, 1);
      }
      return process;
    }

    if (this.props.refund.processes) {
      const newProcess = this.props.refund.processes.find(
        process => process.currentStatus === orderRefundProcessStatus.NEW,
      );
      let process = newProcess ? this.landlordRefundProcess : this.scomRefundProcess;

      if (newProcess && this.props.refund.refundMethod === 'STRIPE') {
        process.splice(1, 1);
      }
      return process;
    }
    return [];
  };
  showStatus = (originalStatus, propsRefundStatus) => {
    if (originalStatus === 'pending') {
      switch (propsRefundStatus) {
        case orderRefundStatus.PENDING_REFUND:
          return 'pending';

        case orderRefundStatus.NEW:
          return 'undo';
        case orderRefundStatus.VOID:
          return 'done';
        case orderRefundStatus.REFUNDED || orderRefundStatus.REFUND_CONFIRMATION:
          return 'done';
      }
    }

    if (originalStatus === 'done') {
      switch (propsRefundStatus) {
        case orderRefundStatus.PENDING_REFUND:
          return 'undo';

        case orderRefundStatus.NEW:
          return 'undo';

        case orderRefundStatus.VOID:
          return 'done';
        case orderRefundStatus.REFUNDED || orderRefundStatus.REFUND_CONFIRMATION:
          return 'done';
      }
    }
    if (originalStatus === 'stripeRefundPending') {
      switch (propsRefundStatus) {
        case orderRefundStatus.PENDING_REFUND:
          return 'pending';

        case orderRefundStatus.NEW:
          return 'undo';
        case orderRefundStatus.VOID:
          return 'done';
        case orderRefundStatus.REFUNDED:
          return 'done';
      }
    }
    if (originalStatus === 'refundPending') {
      switch (propsRefundStatus) {
        case orderRefundStatus.PENDING_REFUND:
          return 'undo';

        case orderRefundStatus.NEW:
          return 'undo';
        case orderRefundStatus.VOID:
          return 'done';
        case orderRefundStatus.REFUNDED:
          return 'done';
      }
    }
    if (originalStatus === 'new') {
      switch (propsRefundStatus) {
        case orderRefundStatus.PENDING_REFUND:
          return 'done';

        case orderRefundStatus.NEW:
          return 'pending';

        case orderRefundStatus.VOID:
          return 'undo';

        case orderRefundStatus.REFUNDED:
          return 'done';
      }
    }
    if (originalStatus === 'accommodationRefundProcessNew') {
      switch (propsRefundStatus) {
        case orderRefundStatus.PENDING_REFUND:
          return 'pending';

        case orderRefundStatus.NEW:
          return 'pending';

        case orderRefundStatus.REFUNDED || orderRefundStatus.VOID:
          return 'done';
      }
    }
  };
  render() {
    const processes = this.showTemplateByRefunds();

    return (
      <div className="refund-process">
        <h3 className="refund-process__title">
          {this.props.t('landlord.longtail_booking_detail.booking_refund.title.refund_process')}
        </h3>
        <ul className="refund-process__list">
          <For of={processes} each="process" index="key">
            <li className="refund-process__item" key={key}>
              <div className={classnames('refund-process__tail')} />
              <div
                className={classnames('refund-process__icon', {
                  'refund-process__icon--undo': process.status === 'undo',
                  'refund-process__icon--pending': process.status === 'pending',

                  'refund-process__icon--done': process.status === 'done',
                })}
              />
              <div className="refund-process__content">
                <p className="refund-process__summary">{process.label}</p>

                <If condition={process.status === 'done' && process.updatedAt}>
                  <p className="refund-process__time">{formatFullTime(process.updatedAt)}</p>
                </If>
              </div>
            </li>
          </For>
        </ul>
      </div>
    );
  }
}

RefundProcess.propTypes = {
  refund: PropTypes.object,
  t: PropTypes.func.isRequired,
};

RefundProcess.defaultProps = {
  refund: {},
  t: () => {},
};
